import React from 'react';
import Icon from '../../../components/AppIcon';

import { useLanguage } from '../../../contexts/LanguageContext';

const DateRangeFilter = ({ dateRange, onChange }) => {
  const { t, currentLanguage } = useLanguage();

  const handleStartDateChange = (value) => {
    onChange({ ...dateRange, startDate: value });
  };

  const handleEndDateChange = (value) => {
    onChange({ ...dateRange, endDate: value });
  };

  const handleQuickSelect = (period) => {
    const endDate = new Date()?.toISOString()?.split('T')?.[0];
    let startDate;

    switch (period) {
      case '3months':
        startDate = new Date(new Date().setMonth(new Date().getMonth() - 3))?.toISOString()?.split('T')?.[0];
        break;
      case '6months':
        startDate = new Date(new Date().setMonth(new Date().getMonth() - 6))?.toISOString()?.split('T')?.[0];
        break;
      case '1year':
        startDate = new Date(new Date().setFullYear(new Date().getFullYear() - 1))?.toISOString()?.split('T')?.[0];
        break;
      default:
        startDate = dateRange?.startDate;
    }

    onChange({ startDate, endDate });
  };

  return (
    <div className="bg-card border border-border rounded-lg shadow-warm p-4 md:p-6">
      <div className="flex items-center gap-3 mb-4">
        <Icon name="Calendar" size={20} className="text-primary" />
        <h3 className="text-sm sm:text-base font-semibold text-foreground">
          {t('common.filter')}
        </h3>
      </div>
      <div className="space-y-4">
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
          <div className="space-y-2">
            <label className="text-xs sm:text-sm text-muted-foreground whitespace-nowrap">
              {t('common.from')}
            </label>
            <input
              type="date"
              value={dateRange?.startDate || ''}
              onChange={(e) => handleStartDateChange(e?.target?.value)}
              className="w-full px-3 py-2 text-sm bg-background border border-border rounded-md focus:outline-none focus:ring-2 focus:ring-primary"
            />
          </div>
          <div className="space-y-2">
            <label className="text-xs sm:text-sm text-muted-foreground whitespace-nowrap">
              {t('common.to')}
            </label>
            <input
              type="date"
              value={dateRange?.endDate || ''}
              onChange={(e) => handleEndDateChange(e?.target?.value)}
              className="w-full px-3 py-2 text-sm bg-background border border-border rounded-md focus:outline-none focus:ring-2 focus:ring-primary"
            />
          </div>
        </div>
        <div className="flex flex-wrap gap-2">
          <button
            onClick={() => handleQuickSelect('3months')}
            className="px-3 py-1.5 text-xs sm:text-sm bg-background hover:bg-muted border border-border rounded-md transition-smooth"
          >
            {t('analytics.threeMonths')}
          </button>
          <button
            onClick={() => handleQuickSelect('6months')}
            className="px-3 py-1.5 text-xs sm:text-sm bg-background hover:bg-muted border border-border rounded-md transition-smooth"
          >
            {t('analytics.sixMonths')}
          </button>
          <button
            onClick={() => handleQuickSelect('1year')}
            className="px-3 py-1.5 text-xs sm:text-sm bg-background hover:bg-muted border border-border rounded-md transition-smooth"
          >
            {t('analytics.oneYear')}
          </button>
        </div>
      </div>
    </div>
  );
};

export default DateRangeFilter;